import React from "react";
import { Profile } from "./dashboard/profile";

export default function SettingsPage() {
  return <Profile />;
}
